import { useGlobalFilters } from 'hooks/useGlobalFilters';

import { DateRangeWrapper } from '@molecules/DateRangeWrapper';

export function LocalDateRangeWrapper() {
  const { filters, setDateRange } = useGlobalFilters();

  return (
    <DateRangeWrapper
      defaultFilters={filters.dateRange}
      onChange={setDateRange}
    />
  );
}
